<template>
    <div>
        <v-card flat min-height="100%">
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-chip-group
                            v-model="type"
                            mandatory
                            active-class="active-chip"
                        >
                            <v-chip class="ml-1 px-6" :value="'residential'">
                                Residencial
                            </v-chip>
                            <v-chip class="ml-1 px-6" :value="'comercial'">
                                Comercial
                            </v-chip>
                            <v-chip class="ml-1 px-6" :value="'industry'">
                                Industrial
                            </v-chip>
                        </v-chip-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-list class="pa-0">
                            <v-list-item-group v-model="tab" active-class="active-rate">
                                <v-list-item
                                v-for="r in rates_filtered"
                                :key="r.name"
                                class="px-10 mb-2 item-rate"
                                >

                                    <v-list-item-content>
                                        {{ r.name }}
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card flat outlined min-height="100%" class="d-flex">
                            <v-card-text class="px-8 text-right" v-if="!isNaN(tab)">
                                <v-subheader class="font-weight-bold pa-0 primary--text">Costos</v-subheader>
                                <v-text-field
                                    v-model="price"
                                    prefix="$"
                                    type="number"
                                    dense
                                    flat
                                    outlined
                                    label="Costo promedio"
                                    suffix="KWH"
                                    @keydown="changes = true"
                                ></v-text-field>
                                <v-text-field
                                    v-if="rate.rate === FIXED || rate.rate === PROPORTIONAL"
                                    v-model="base"
                                    prefix="$"
                                    type="number"
                                    dense
                                    flat
                                    outlined
                                    label="Cargo fijo"
                                    @keydown="changes = true"
                                ></v-text-field>
                                <v-text-field
                                    v-if="rate.rate === PROPORTIONAL"
                                    v-model="demand"
                                    prefix="$"
                                    type="number"
                                    dense
                                    flat
                                    outlined
                                    label="Demanda"
                                    @keydown="changes = true"
                                ></v-text-field>
                                <v-btn color="accent" @click="save" :disabled="!changes">Guardar</v-btn>
                            </v-card-text>
                            <v-card-text class="text-center ma-auto" v-else>
                                Selecciona una tarifa
                            </v-card-text>
                        </v-card>          
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { FIXED, PROPORTIONAL } from '../../plugins/rates'

export default {
    name: 'rates',
    computed: {
        ...mapState({
            rates(state){
                if(state.account.profile)
                    return state.account.profile.rates
                return []
            }
        })
    },
    data() {
        return {
            tab: undefined,
            rates_filtered: [],
            rate: null,
            type: null,
            changes: false,
            price: null,
            base: null,
            demand: null,
            FIXED, PROPORTIONAL
        }
    },
    methods: {
        ...mapActions({ updateRate: 'account/updatedRates' }),
        updateList(){
            if(this.type)
                this.rates_filtered = this.rates.filter( r => r.type === this.type )
        },
        async save(){
            try {
                const new_rate = {
                    name: this.rate.name,
                    type: this.rate.type,
                    rate: this.rate.rate
                }

                isNaN(parseFloat(this.price)) ? new_rate.price = 0 : new_rate.price = this.price
                if(this.rate.rate === FIXED || this.rate.rate === PROPORTIONAL)
                    isNaN(parseFloat(this.base)) ? new_rate.base = 0 : new_rate.base = this.base
                if(this.rate.rate === PROPORTIONAL)
                    isNaN(parseFloat(this.demand)) ? new_rate.demand = 0 : new_rate.demand = this.demand

                await this.updateRate({
                    old_rate: this.rates.find( r => r.name === this.rate.name ),
                    new_rate
                })
                this.updateList()
                this.changes = false
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch: {
        tab(){
            if(isNaN(this.tab)) return

            this.rate = this.rates_filtered[this.tab]
            this.price = this.rate.price
            this.rate.base ? this.base = this.rate.base: this.base = null 
            this.rate.demand ? this.demand = this.rate.demand: this.demand = null

            this.changes = false
        },
        type(){
            this.updateList()
            this.changes = false
        }
    },
}
</script>

<style scoped>
    .active-chip{
        color: var(--v-accent-base) !important;
        background-color: white !important;
        box-shadow: 0 0 16px -9px black;
    }
    .v-chip{
        border-radius: 5px;
        font-size: 12px;
        height: 30px;
    }
    .v-chip:before {
        background-color: unset;
    }
    .active-rate{
        border-color: var(--v-accent-base) !important;
        box-shadow: 0 0 16px -11px black;
    }
    .item-rate{
        border-radius: 5px;
        border: 1px solid;
        border-color: var(--v-background-darken1);
    }
    .v-list-item--link:before {
        opacity: 0 !important;
    }
</style>